import React from "react";
import { Box, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { SLIDING_PUZZLE_QUEST_GOOGLE_PLAY_URL } from "../../config/nativeAppsVisibility";
import { usePagesTranslation } from "../locales";
import { storeBadgeChromeSx, storeBadgeLine1Sx, storeBadgeLine2Sx } from "./storeBadgeChrome";

function GooglePlayMark({ size }) {
    return (
        <Box
            component="svg"
            viewBox="0 0 24 24"
            aria-hidden
            sx={{ width: size, height: size, flexShrink: 0, display: "block" }}
        >
            <path fill="#4285F4" d="M3.2 2.4v19.2L13.6 12 3.2 2.4z" />
            <path fill="#34A853" d="M13.6 12 3.2 21.6c.4.7 1.3 1 2.1.6L18 15.4 13.6 12z" />
            <path fill="#FBBC04" d="M20.4 10.7 18 9.3 13.6 12 18 14.7l2.4-1.4c.8-.5.8-1.7 0-2.6z" />
            <path fill="#EA4335" d="M3.2 2.4C3.6 1.7 4.5 1.4 5.3 1.8L18 8.6 13.6 12 3.2 2.4z" />
        </Box>
    );
}

/**
 * Google Play link styled to match the App Store badge.
 */
export default function GooglePlayBadgeLink({
    href = SLIDING_PUZZLE_QUEST_GOOGLE_PLAY_URL,
    height = 40,
    sx = {},
    ariaLabel,
}) {
    const { t } = usePagesTranslation();
    const label =
        ariaLabel
        ?? t(
            "landing.google-play-badge-aria",
            "Get Sliding Puzzle Quest on Google Play (opens in a new tab)",
        );
    const line1 = t("landing.google-play-download-line1", "GET IT ON");
    const line2 = t("landing.google-play-download-line2", "Google Play");

    return (
        <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            sx={{ ...storeBadgeChromeSx(height), ...sx }}
        >
            <GooglePlayMark size={height * 0.58} />
            <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.05, minWidth: 0 }}>
                <Typography component="span" sx={storeBadgeLine1Sx(height)}>
                    {line1}
                </Typography>
                <Typography component="span" sx={storeBadgeLine2Sx(height)}>
                    {line2}
                </Typography>
            </Box>
        </Link>
    );
}

GooglePlayBadgeLink.propTypes = {
    href: PropTypes.string,
    height: PropTypes.number,
    sx: PropTypes.object,
    ariaLabel: PropTypes.string,
};
